import { useGlobalContext } from "../../context/global/state";

type experience = "member" | "employer";

const capitalize = (string) =>
	`${string.charAt(0).toUpperCase()}${string.slice(1)}`;

// Plan reference to global data properties
// TODO: This is a temporary fix for displayPlans id name (needs, for example: memberDefinedBenefit => member-db)
const planReferenceGlobal = new Map([
	["memberDefinedContribution", "member"],
	["memberDefinedBenefit", "member-db"],
	["memberEsop", "member-esop"],
	["memberNonqualified", "member-nq"],
	["memberEquityCompensation", "member-ec"],
	["memberEquityCompensationPrivate", "member-ec-private"],
	["employerDefinedContribution", "employer"],
	["employerDefinedBenefit", "employer-db"],
	["employerEsop", "employer-esop"],
	["employerNonqualified", "employer-nq"],
	["employerEquityCompensationPrivate", "employer-ec-private"],
]);

interface Query {
	experience: experience;
	properties?: string[];
}

export const plansMap = new Map();
export const useDisplayPlansData = (
	experience: Query["experience"],
	properties: Query["properties"] = [],
) => {
	const { data } = useGlobalContext();
	const plan = data.displayPlans[experience];
	const planSet = Object.keys(plan);

	planSet.forEach((item) => {
		const planName = capitalize(item);
		const planId = `${experience}${planName}`;
		const globalId = planReferenceGlobal.get(planId);
		const globalPlanData = data[globalId ?? item];

		let displayPlans = {
			...plan[item],
		};

		properties.forEach((property) => {
			displayPlans = { ...displayPlans, ...globalPlanData[property] };
		});

		const parseUrl = displayPlans.url.replace("./react/index.html#", "");
		displayPlans.url = parseUrl;

		plansMap.set(item, displayPlans);
	});

	const result = [...plansMap.values()];

	const selected = result.filter((plan) => String(plan.selected) === "true");

	const anyPlansSelected: boolean = selected.length !== 0;

	return {
		result,
		filter: { selected: anyPlansSelected ? selected : result },
	};
};
